import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './WelcomeBackBanner.css';

const WelcomeBackBanner = () => {
  const { anonymousActivity, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Don't show banner if user is authenticated or has no content
  if (isAuthenticated || !anonymousActivity.hasContent) {
    return null;
  }

  const handleCreateAccount = () => {
    navigate('/accounts/signup/');
  };

  return (
    <div className="welcome-back-banner">
      <div className="welcome-back-banner-content">
        <h3>Welcome back to Weaver's World!</h3>
        <p>
          {anonymousActivity.storiesCreated > 0 && anonymousActivity.charactersCreated > 0 ? (
            <>
              You've created {anonymousActivity.storiesCreated} {anonymousActivity.storiesCreated === 1 ? 'story' : 'stories'} and {anonymousActivity.charactersCreated} {anonymousActivity.charactersCreated === 1 ? 'character' : 'characters'}.
            </>
          ) : anonymousActivity.storiesCreated > 0 ? (
            <>
              You've created {anonymousActivity.storiesCreated} {anonymousActivity.storiesCreated === 1 ? 'story' : 'stories'}.
            </>
          ) : (
            <>
              You've created {anonymousActivity.charactersCreated} {anonymousActivity.charactersCreated === 1 ? 'character' : 'characters'}.
            </>
          )}
        </p>
        <p>Create an account to save your creations!</p>
        <button className="welcome-back-button" onClick={handleCreateAccount}>
          Create Account
        </button>
      </div>
    </div>
  );
};

export default WelcomeBackBanner;